import * as React from "react";
import { ProductInventory } from "../Inventory/ProductInventory/ProductInventory";
import { Product } from "./types";

export type addToCartViewState = "button" | "inventory";

export const AddToCartButton: React.FunctionComponent<{
  item: Product;
  onProductAddToCartClick: () => void;
}> = (props) => {
  const [viewState, setViewState] =
    React.useState<addToCartViewState>("inventory");

  const handleInventory = (result: InventoryResult) => {
    if (result.StoreNumber) {
      setViewState("button");
    }
  };

  const productId = props.item.ProductId;
  const upc = props.item.UpcOrCode;

  if (viewState === "button") {
    return (
      <button
        type="button"
        className="prod-button"
        title={`add ${props.item.Name} to cart`}
        onClick={(e) => {
          e.preventDefault();
          props.onProductAddToCartClick();
        }}
      >
        Add to Order
      </button>
    );
  }

  if (viewState === "inventory") {
    return (
      <ProductInventory
        UPC={upc}
        ProductId={productId}
        onInventoryChecked={handleInventory}
      />
    );
  }

  return <></>;
};
